import { render, staticRenderFns } from "./update-main-info.vue?vue&type=template&id=1f928608&scoped=true"
import script from "./update-main-info.vue?vue&type=script&lang=js"
export * from "./update-main-info.vue?vue&type=script&lang=js"
import style0 from "./update-main-info.vue?vue&type=style&index=0&id=1f928608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f928608",
  null
  
)

export default component.exports